import { PreboardingTaskRow } from "@/pages/preboarding/components/PreboardingTaskRow.tsx";
import { ApiFormParticipantStatus } from "@/types/forms/form.types.ts";
import { ApiSurveyParticipantView } from "@/types/survey.types.ts";
import { ButtonLink, FontAwesomeIcon } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface PreboardingSurveyRowProps {
  survey: ApiSurveyParticipantView;
}

export function PreboardingSurveyRow({ survey }: PreboardingSurveyRowProps) {
  const { t } = useTranslation();

  const isInProgress = survey.participant_status === ApiFormParticipantStatus.in_progress;

  return (
    <PreboardingTaskRow
      emoji={survey.survey.emoji || ":memo:"}
      title={survey.survey.title}
      action={
        <ButtonLink
          href={`/surveys/${survey.survey.id}/respond`}
          variant={"plain"}
          rightIcon={<FontAwesomeIcon icon="fa-light fa-chevron-right" />}
        >
          {isInProgress ? t("common:continue") : t("core:preboarding_start")}
        </ButtonLink>
      }
    />
  );
}
